// FaqPage.js
import './faq-page.styles.css';

import FaqImg from "../../../assets/images/faq-banner.jpg";
import MiniForm from '../../../components/mini-form/mini-form/mini-form.component';
import FaqContent from '../../../components/faq-content/faq-content/faq-content.component';
import IntroBanner from '../../../components/intro-banner/intro-banner/intro-banner.component'

const FaqPage = () => {
    const faqBannerData = [
        {
            img: FaqImg,
            title: "سوالات متداول"
        }
    ];

    return (
        <div className="faq-page">
            <IntroBanner cat={faqBannerData[0]} />

            <div className="container">

                <div className="faq-page-content-wrapper">
                    <FaqContent />
                    <MiniForm />
                </div>

            </div>

        </div>

    );
}

export default FaqPage;
